import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "is-tms-a-medication",
  title: "Is TMS a Medication?",
  description:
    "No. TMS is a non-invasive treatment that uses magnetic stimulation, not medication, to stimulate targeted areas of the brain associated with mood regulation.",
  keywords:
    "is TMS a medication, TMS medication or not, TMS non-medication, magnetic stimulation depression",
  badge: "Educational Article",
  heroTitle: "Is TMS a Medication?",
  heroSubtitle:
    "No. TMS is a non-invasive treatment that uses magnetic stimulation rather than medication to stimulate targeted areas of the brain associated with mood regulation.",
  sections: [
    {
      heading: "How TMS Works",
      body: "TMS uses a magnetic coil placed on the scalp to deliver focused magnetic pulses to specific areas of the brain involved in mood. There is no pill, no injection, and no chemical introduced into your body.",
    },
    {
      heading: "How It Differs From Medication",
      body: "Oral antidepressants work by altering chemical systems in the brain through medication. TMS works by using magnetic energy to influence brain activity directly. They are fundamentally different approaches.",
    },
    {
      heading: "Can Be Used With or Without Medication",
      body: "Because TMS is not a medication, it may be used alongside oral antidepressants. Whether that's appropriate is a clinical decision. Do not stop or change medication without discussing it with your prescriber.",
      callout: true,
    },
    {
      heading: "No Anesthesia Required",
      body: "TMS is performed while you are awake. There is no anesthesia, no sedation, and for standard TMS, you can typically drive yourself home afterward.",
    },
  ],
  faq: [
    {
      question: "Will TMS add another medication to my regimen?",
      answer:
        "No. TMS is not a medication. It uses magnetic stimulation, not a chemical substance. It may be used alongside your current medications, but it doesn't add a new drug to your regimen.",
    },
    {
      question: "Is TMS the same as electroconvulsive therapy (ECT)?",
      answer:
        "No. TMS is non-invasive and does not require anesthesia or induce a seizure. ECT is a different treatment with a different mechanism and experience.",
    },
  ],
  related: [
    { title: "What Is TMS?", href: "/what-is-tms" },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
    {
      title: "Can You Take Antidepressants During TMS?",
      href: "/can-you-take-antidepressants-during-tms",
    },
  ],
  finalCtaText:
    "Questions about how TMS works are completely normal. Speak with our team to learn more.",
});
